import React, { PureComponent } from "react";
import debounce from "lodash.debounce";

import styles from "./Categories.local.scss";
import classnames from "classnames";
import _ from "i18n";

export default class CategoriesComponent extends PureComponent {
  constructor() {
    super();

    this.state = {
      sort: "",
      activeCat: null,
      hasOverflow: false,
      canScrollLeft: false,
      canScrollRight: false
    };

    this.checkForOverflow = this.checkForOverflow.bind(this);
    this.checkForScrollPosition = this.checkForScrollPosition.bind(this);

    this.debounceCheckForOverflow = debounce(this.checkForOverflow, 1000);
    this.debounceCheckForScrollPosition = debounce(
      this.checkForScrollPosition,
      200
    );

    this.container = null;
  }

  checkForScrollPosition() {
    const { scrollLeft, scrollWidth, clientWidth } = this.container;

    this.setState({
      canScrollLeft: scrollLeft > 0,
      canScrollRight: scrollLeft !== scrollWidth - clientWidth
    });
  }

  checkForOverflow() {
    const { scrollWidth, clientWidth } = this.container;
    const hasOverflow = scrollWidth > clientWidth;

    this.setState({ hasOverflow });
  }

  componentDidMount() {
    this.checkForOverflow();
    this.checkForScrollPosition();

    this.container.addEventListener(
      "scroll",
      this.debounceCheckForScrollPosition
    );
  }

  componentDidUpdate(prevProps, prevState) {
    // if (prevState.items.length !== this.state.items.length) {
    this.checkForOverflow();
    this.checkForScrollPosition();
    // }
  }

  renderFetching() {
    return (
      <ul className={classnames(styles.fetching)}>
        <li /> <li /> <li /> <li /> <li /> <li />
      </ul>
    );
  }

  handelClick = category => {
    const { setFilter, fetchMedias } = this.props;
    let filter = this.props.filter;
    if (filter.type === "ALBUM") filter.type = "ALL";
    if (
      !filter.category ||
      (filter.category && filter.category.id !== category.id)
    ) {
      filter.tags = [];
      filter.category = category;
      setFilter(filter);
      fetchMedias({ filterBy: filter, limit: 42 });
    } else {
      filter.category = "";
      setFilter(filter);
      fetchMedias({ filterBy: filter, limit: 42 });
    }
  };

  scrollContainerBy(distance) {
    this.container.scrollBy({ left: distance, behavior: "smooth" });
  }

  handelSelectChange = e => {
    const { fetchCategories } = this.props;
    this.setState({
      sort: e.target.value
    });
    fetchCategories(e.target.value);
  };

  render() {
    const { canScrollRight, canScrollLeft } = this.state;
    const { categories, fetching, lng, filter } = this.props;
    const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;

    return (
      <div className={styles.filter}>
        <select onChange={this.handelSelectChange} value={this.state.sort}>
          <option value="">{_("Popular")}</option>
          <option value="ASC">{_("From A to Z")}</option>
          <option value="DESC">{_("From Z to A")}</option>
        </select>
        <div
          className={styles["cat-container"]}
          ref={node => {
            this.container = node;
          }}
        >
          {fetching ? (
            this.renderFetching()
          ) : !categories || categories.length === 0 ? null : (
            <ul>
              {categories.map(category => (
                <li
                  className={
                    filter.category && filter.category.id === category.id
                      ? styles.activated
                      : ""
                  }
                  onClick={() => this.handelClick(category)}
                >
                  {category[nameAttr]}
                </li>
              ))}
            </ul>
          )}
        </div>
        <i
          className={classnames(
            styles.moreTags,
            "icon icon-arrow-left",
            !canScrollLeft ? "v-hidden" : ""
          )}
          onClick={() => {
            this.scrollContainerBy(-200);
          }}
        />
        <i
          className={classnames(
            styles.moreTags,
            "icon icon-arrow-right",
            !canScrollRight ? "v-hidden" : ""
          )}
          onClick={() => {
            this.scrollContainerBy(200);
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/Header/Categories/CategoriesComponent.js